import { API_HOST } from '@/config';
import client, { ApiRoutes } from '@/store/client';
import { useMutation } from 'react-query';
import { useToast } from '@/hooks/useToast';
import { PublishRequest, Announcement } from '../types';
import { ANNOUNCEMENTS_QUERY_KEY, ErrorMessage, extractServerErrorMsg } from '@/queries';
import { queryClient } from '@/reactQueryClient';
import { AxiosError } from 'axios';

export const usePublishAnnouncement = () => {
  const { toast } = useToast();

  const publishAnnouncementMutation = useMutation(
    ({ featureId, announcementId }: PublishRequest) => {
      return client.post<Announcement>(
        `${API_HOST}/${ApiRoutes.Announcements}/${featureId}/announcements/${announcementId}/publish`,
        {},
      );
    },
    {
      onError: (errorResponse: AxiosError) => {
        toast(extractServerErrorMsg(errorResponse, 'Failed to publish announcement.'), {
          variant: 'error',
        });
      },
      onSuccess: (_, { featureId }) => {
        queryClient.invalidateQueries([ANNOUNCEMENTS_QUERY_KEY, featureId]);
        toast('Announcement published successfully.', {
          variant: 'success',
        });
      },
    },
  );

  const {
    mutateAsync: publishAnnouncement,
    isLoading,
    error,
  } = publishAnnouncementMutation;
  const serverErrors: ErrorMessage[] = error?.response?.data?.errors || [];

  return { isLoading, serverErrors, publishAnnouncement };
};
